module.exports = __webpack_public_path__ + "static/media/r&d.209cc8d0.jpg";